/* This file is automatically generated, do not edit manually! */

/* eslint-disable */

exports.BADA_MODELS = {
    'GT- ?S52(50|53)!'                          : [ 'Samsung', 'Wave 525' ],
    'GT-S53(30|33)!'                            : [ 'Samsung', 'Wave 533' ],
    'GT-S5380!'                                 : [ 'Samsung', 'Wave Y' ],
    'GT-S57(50|53)!'                            : [ 'Samsung', 'Wave 575' ],
    'GT-S57(80)!'                               : [ 'Samsung', 'Wave 578' ],
    'GT-S72(30|33)!'                            : [ 'Samsung', 'Wave 723' ],
    'GT-S7250!'                                 : [ 'Samsung', 'Wave M' ],
    'GT-S8500!'                                 : [ 'Samsung', 'Wave' ],
    'SCH-F859!'                                 : [ 'Samsung', 'Wave' ],
    'GT- ?S8530!'                               : [ 'Samsung', 'Wave II' ],
    'GT- ?S8600!'                               : [ 'Samsung', 'Wave 3' ],
    'SHW-M410'                                  : [ 'Samsung', 'Wave 3' ]
};

/* This file is automatically generated, do not edit manually! */
